import { envs } from '@/app/utils/envs';

export const IS_PROJECT_DETAIL_AB_TESTING_ACTIVE = true;

export enum ProjectDetailGroup {
  Control = 'Control',
  FloatingButtons = 'FloatingButtons',
  NewHeaderLayout = 'NewHeaderLayout',
  SubProjectBoxReplace = 'SubProjectBoxReplace',
  AllExperiments = 'AllExperiments',
}

export const edges: Record<ProjectDetailGroup, number[]> = {
  [ProjectDetailGroup.Control]: [1, 4],
  [ProjectDetailGroup.FloatingButtons]: [5, 8],
  [ProjectDetailGroup.NewHeaderLayout]: [9, 12],
  [ProjectDetailGroup.SubProjectBoxReplace]: [13, 16],
  [ProjectDetailGroup.AllExperiments]: [17, 20],
};

export const getProjectDetailGroup = (group: number | undefined): ProjectDetailGroup => {
  if (group === undefined) {
    return ProjectDetailGroup.Control;
  }

  for (const [key, [start, end]] of Object.entries(edges)) {
    if (group >= start && group <= end) {
      return key as ProjectDetailGroup;
    }
  }

  return ProjectDetailGroup.Control;
};

export const isUserInFloatingButtonsGroup = (group: string): boolean => {
  if (envs.isInCypressTesting) {
    return false;
  }
  const parsedGroup = Number(group);

  if (Number.isNaN(parsedGroup)) {
    return false;
  }

  const projectDetailGroup = getProjectDetailGroup(parsedGroup);

  return [ProjectDetailGroup.FloatingButtons, ProjectDetailGroup.AllExperiments].includes(projectDetailGroup);
};

export const isUserInNewHeaderLayoutGroup = (group: string): boolean => {
  if (envs.isInCypressTesting) {
    return false;
  }
  const parsedGroup = Number(group);

  if (Number.isNaN(parsedGroup)) {
    return false;
  }

  const projectDetailGroup = getProjectDetailGroup(parsedGroup);

  return [ProjectDetailGroup.NewHeaderLayout, ProjectDetailGroup.AllExperiments].includes(projectDetailGroup);
};

export const isUserInSubProjectBoxReplaceGroup = (group: string): boolean => {
  if (envs.isInCypressTesting) {
    return false;
  }
  const parsedGroup = Number(group);

  if (Number.isNaN(parsedGroup)) {
    return false;
  }

  const projectDetailGroup = getProjectDetailGroup(parsedGroup);

  return [ProjectDetailGroup.SubProjectBoxReplace, ProjectDetailGroup.AllExperiments].includes(projectDetailGroup);
};
